import { useAppDispatch } from "app.hook";
import { FormikErrors, FormikProps, useFormik } from "formik";
import React, { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MainContainer } from "shared/components/layout/style/layout-internal-style";
import { ACCOUNT_LOGIN_ROUTE } from "shared/constants/routes";
import { updatePasswordAPI } from "states/account/account.api";
import { IChangedPasswordModel } from "states/account/account.models";
import { setLoading, showError, showSuccess } from "states/global-value/global-value.slice";
import { IconSuccess } from "themes/icons";
import { PrimaryButton } from "themes/style-components/button";
import { FlexAuto } from "themes/style-components/flex";
import { FormControl, FormError, FormGroup, FormGroupNotFlex, FormLabel } from "themes/style-components/form-group";
import { FormChangePassword } from "./style/change-password-style";

const ChangePasswordPage: FC = (props) => {
  const dispatch = useAppDispatch();
  const [isSuccess, setSuccess] = useState<boolean>(false);
  const formik: FormikProps<IChangedPasswordModel> = useFormik<IChangedPasswordModel>({
    initialValues: {
      newPassword: "",
      currentPassword: "",
      confirmPassword: "",
    },
    validateOnChange: true,
    validate: (values) => {
      let errors: FormikErrors<IChangedPasswordModel> = {};
      if (values.currentPassword === "") {
        errors.currentPassword = "Please enter current password";
      }
      if (values.newPassword === "") {
        errors.newPassword = "Please enter new password";
      }
      else if (values.newPassword.length < 6) {
        errors.newPassword = "At least 6 characters";
      }
      if (values.confirmPassword === "") {
        errors.confirmPassword = "Please enter confirm password";
      } else if (values.newPassword !== values.confirmPassword) {
        errors.confirmPassword = "Password must match";
      }
      return errors;
    },
    onSubmit: async (values) => {
      dispatch(setLoading(true));
      try {
        await updatePasswordAPI(values);
        dispatch(setLoading(false));
        dispatch(showSuccess("Updated successfully"));
        setSuccess(true);
      } catch (err  : any) {
        dispatch(setLoading(false));
        dispatch(showError(err?.response?.data?.error?.message));
      }
    },
  });

  useEffect(() => {
    document.title = "Change Password";
  
  }, [])
  return (
    <MainContainer>
      {isSuccess ? (
        <div className="text-center mx-auto">
          <IconSuccess width={50} className="mb-3 text-center mx-auto" />
          <p>Updated password successfully</p>
          <Link to={ACCOUNT_LOGIN_ROUTE}>
            <PrimaryButton className="block w-full mt-4" type="button">Back</PrimaryButton>
          </Link>
        </div>

      ) : (
        <FormChangePassword onSubmit={formik.handleSubmit}>
          <FormGroupNotFlex className="mb-4">
            <FormLabel htmlFor="currentPassword" >Current Password</FormLabel>
            <FlexAuto>
              <FormControl>
                <input
                  id="currentPassword"
                  name="currentPassword"
                  type="password"
                  placeholder="Current Password"
                  onChange={formik.handleChange}
                  value={formik.values.currentPassword}
                />
              </FormControl>
              {formik.errors.currentPassword && (
                <FormError>
                  {formik.errors.currentPassword}
                </FormError>
              )}
            </FlexAuto>
          </FormGroupNotFlex>
          <FormGroupNotFlex className="mb-4">
            <FormLabel htmlFor="newPassword" >New Password</FormLabel>
            <FlexAuto>
              <FormControl>
                <input id="newPassword"
                  name="newPassword"
                  type="password"
                  placeholder="New Password"
                  onChange={formik.handleChange}
                  value={formik.values.newPassword} />
              </FormControl>
              {formik.errors.newPassword && (
                <FormError>
                  {formik.errors.newPassword}
                </FormError>
              )}
            </FlexAuto>
          </FormGroupNotFlex>
          <FormGroupNotFlex className="mb-4">
            <FormLabel htmlFor="confirmPassword" >Confirm Password</FormLabel>
            <FlexAuto>
              <FormControl>
                <input id="confirmPassword"
                  name="confirmPassword"
                  type="password"
                  placeholder="Confirm Password"
                  onChange={formik.handleChange}
                  value={formik.values.confirmPassword} />
              </FormControl>
              {formik.errors.confirmPassword && (
                <FormError>
                  {formik.errors.confirmPassword}
                </FormError>
              )}
            </FlexAuto>
          </FormGroupNotFlex>
          <FormGroupNotFlex className="mb-4">
            <PrimaryButton className="block w-full mt-4" type="submit">Save</PrimaryButton>
          </FormGroupNotFlex>
        </FormChangePassword>
      )}
    </MainContainer>
  );
};

export default ChangePasswordPage;
